import type { HealthLevel } from '../models/device';

/** tr-TR binlik ayraçlı sayı (mock ile birebir: 2.850 gibi). */
export function nfmt(n: number): string {
  return n.toLocaleString('tr-TR');
}

/** eMMC ömrünü JEDEC hex yazımıyla göster: 11 → "0x0B". */
export function hex2(n: number): string {
  return '0x' + n.toString(16).toUpperCase().padStart(2, '0');
}

/* Eşik değerlendirmeleri — backend'deki varsayılanlarla aynı (75/85, 80/90, 0x08/0x0A).
   Panel, Ayarlar'dan gelen güncel eşiklerle çağırır. */
export function tempLevel(t: number | null, warn = 75, crit = 85): HealthLevel {
  return t == null ? 'off' : t >= crit ? 'crit' : t >= warn ? 'warn' : 'ok';
}
export function diskLevel(d: number | null, warn = 80, crit = 90): HealthLevel {
  return d == null ? 'off' : d >= crit ? 'crit' : d >= warn ? 'warn' : 'ok';
}
export function emmcLevel(e: number | null, warn = 0x08, crit = 0x0a): HealthLevel {
  return e == null ? 'off' : e >= crit ? 'crit' : e >= warn ? 'warn' : 'ok';
}

/** Durum → metin rengi (CSS var). */
export function levelColor(level: HealthLevel): string {
  return {
    ok: 'var(--vx-success-text)',
    warn: 'var(--vx-warning-text)',
    crit: 'var(--vx-danger-text)',
    off: 'var(--vx-text-3)',
  }[level];
}

/** Durum → dolgu rengi (bar/grafik). */
export function levelFill(level: HealthLevel): string {
  return {
    ok: 'var(--vx-success)',
    warn: 'var(--vx-warning)',
    crit: 'var(--vx-danger)',
    off: 'var(--vx-text-3)',
  }[level];
}

/** Saniyeyi kısa süreye çevir: 90 → "1 dk", 7200 → "2 sa", 260000 → "3g". */
export function shortDuration(sec: number | null): string {
  if (sec == null) return '—';
  if (sec < 90) return 'az önce';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} dk`;
  const hours = Math.round(min / 60);
  if (hours < 48) return `${hours} sa`;
  return `${Math.round(hours / 24)}g`;
}

/** Avatar baş harfleri: "Elif Kaya" → "EK", "admin" → "AD". */
export function initials(nameOrUsername: string): string {
  const parts = nameOrUsername.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  return nameOrUsername.slice(0, 2).toUpperCase();
}
